/**
 * Application color constants
 */
export const COLORS = {
  STATUS: {
    PENDING_APPROVAL: '#ff9800',
    UNPAID: '#f44336',
    PAID: '#4caf50',
    CHECKED_IN: '#2196f3'
  },
  DATE: {
    SUNDAY: '#f44336',
    SATURDAY: '#97e6d8',
    DEFAULT: '#000000'
  }
} as const;
